import { buildApiUrl } from "./apiClientService";

export async function fetchFeatureFlagsPublic() {
  const res = await fetch(buildApiUrl("/api/platform/features"), {
    credentials: "omit",
  });
  if (!res.ok) {
    throw new Error("feature flags fetch failed");
  }
  return res.json();
}
